import { Box, Collapse, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import AppsIcon from "@mui/icons-material/Apps";
import EmailIcon from "@mui/icons-material/Email";
import GroupIcon from "@mui/icons-material/Group";
import BookIcon from "@mui/icons-material/Book";

import MenuItem from "./MenuItem";
import { useLocation } from "react-router-dom";

const AdminSidebar = () => {
  const location = useLocation();
  return (
    <Box className="bg-slate-300 overflow-y-auto h-full overflow-x-hidden min-h-screen" sx={{ width: "280px", height: "calc(100vh - 64px)" }}>
      <>
        <List component="nav">
          <MenuItem isActive={location.pathname.includes("plugin-list")} to="/plugin-list" text={"Plugin List"} icon={<AppsIcon />}></MenuItem>
          <MenuItem isActive={location.pathname.includes("smtp-setup")} to="/smtp-setup" text={"SMTP Setup"} icon={<EmailIcon />}></MenuItem>
          <MenuItem isActive={location.pathname.includes("users")} to="/users" text={"Users"} icon={<GroupIcon />}></MenuItem>
          <MenuItem isActive={location.pathname.includes("logs")} to="/logs" text={"Logs"} icon={<BookIcon />}></MenuItem>
        </List>
      </>
    </Box>
  );
};

export default AdminSidebar;
